import { useTranslation } from "react-i18next";

export const LanguageSelector = () => {
    const [t, i18n] = useTranslation('common');
    return (
        <div className="row pe-3">
            {/*<div className="d-flex justify-content-end">
                <span>{t('language-selector.label')} </span>
                <div
                    onClick={() => i18n.changeLanguage('fr')}
                    style={{ cursor: 'pointer' }}
                >
                    Fr
                </div>
                &nbsp;
                <div>/</div>
                &nbsp;
                <div
                    onClick={() => i18n.changeLanguage('en')}
                    style={{ cursor: 'pointer' }}
                >
                    En
                </div>
            </div>
            */}
        </div>
    )
}

